exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".notificationLoading {\n  display: block;\n  position: fixed;\n  opacity: 0.9;\n  background-color: white;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 102; }\n\n.loader {\n  position: absolute;\n  top: calc(50% - 20px);\n  left: calc(50% - 20px);\n  border: 4px solid #ffffff;\n  border-radius: 50%;\n  border-top: 4px solid #004272;\n  width: 40px;\n  height: 40px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n  -webkit-filter: blur(0px) !important;\n  filter: blur(0px) !important; }\n\n/* Safari */\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/LoadScreen/styles.scss
// module id = 1256
// module chunks = 0